import { render } from "./ChatField.vue?vue&type=template&id=4e927d42&scoped=true"
import script from "./ChatField.vue?vue&type=script&lang=js"
export * from "./ChatField.vue?vue&type=script&lang=js"

import "./ChatField.vue?vue&type=style&index=0&id=4e927d42&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e927d42"]])

export default __exports__